import { toastr } from 'react-redux-toastr';

import Config from '../config';
import xlsxExport from '../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { ExcelUser } from '../shared/queries/users';
import usersAndPrivilegesColumnDefinitions from '../shared/columnDefinitions/usersAndPrivileges';

type DownloadExcelParams = {
  users: ExcelUser[],
  environmentSuffix: string,
}

export default async ({
  users,
  environmentSuffix,
}: DownloadExcelParams) => {
  const sheetData = [
    {
      name: 'Users and privileges',
      type: SheetExportTypes.GRID,
      columnDefinitions: [
        ...usersAndPrivilegesColumnDefinitions,
      ],
      data: users,
      options: {
        hideDecimals: false,
        negativeMinus: true,
        shouldDisplayZero: true,
      },
    },
  ];

  try {
    await xlsxExport({
      sheetData,
      metadata: {
        fileName: `TLS_Users_and_privileges_${environmentSuffix}`,
        disableHeaderRendering: true,
      },
    });
  } catch (error) {
    toastr.error('', 'Exporting data to the excel file failed', Config.defaultToastrSettings);
  }
};
